const data = JSON.parse(localStorage.getItem("language"));

const init = {
  lang: data ? (data.lang ? data.lang : "en") : "en",
  dir: data ? (data.dir ? data.dir : "ltr") : "ltr"
};

const language = (state = init, action) => {
  switch (action.type) {
    case "SET_LANG":
      localStorage.setItem("language", JSON.stringify(action.data));
      return action.data;
    default:
      return state;
  }
};

export default language;
